import {
  createBackup as publicCreateBackup,
  listBackups as publicListBackups,
  restoreBackup as publicRestoreBackup,
  restorePartialBackup as publicRestorePartialBackup,
  listRestorations as publicListRestorations,
  deleteBackup as publicDeleteBackup,
} from './data-v2-backup-backups.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onBackupStateChanged as publicOnBackupStateChanged } from './data-v2-backup-backups.public.js';
import { onBackupRestorationStateChanged as publicOnBackupRestorationStateChanged } from './data-v2-backup-backups.public.js';

export const createBackup: MaybeContext<
  BuildRESTFunction<typeof publicCreateBackup> & typeof publicCreateBackup
> = /*#__PURE__*/ createRESTModule(publicCreateBackup);
export const listBackups: MaybeContext<
  BuildRESTFunction<typeof publicListBackups> & typeof publicListBackups
> = /*#__PURE__*/ createRESTModule(publicListBackups);
export const restoreBackup: MaybeContext<
  BuildRESTFunction<typeof publicRestoreBackup> & typeof publicRestoreBackup
> = /*#__PURE__*/ createRESTModule(publicRestoreBackup);
export const restorePartialBackup: MaybeContext<
  BuildRESTFunction<typeof publicRestorePartialBackup> &
    typeof publicRestorePartialBackup
> = /*#__PURE__*/ createRESTModule(publicRestorePartialBackup);
export const listRestorations: MaybeContext<
  BuildRESTFunction<typeof publicListRestorations> &
    typeof publicListRestorations
> = /*#__PURE__*/ createRESTModule(publicListRestorations);
export const deleteBackup: MaybeContext<
  BuildRESTFunction<typeof publicDeleteBackup> & typeof publicDeleteBackup
> = /*#__PURE__*/ createRESTModule(publicDeleteBackup);
/**
 * Triggered when a backup's status is changed. This includes when a backup is created and its status is set to `PENDING`.
 */
export const onBackupStateChanged: BuildEventDefinition<
  typeof publicOnBackupStateChanged
> &
  typeof publicOnBackupStateChanged = createEventModule(
  publicOnBackupStateChanged
);
/**
 * Triggered when a restoration's status is changed. This includes when a new restoration is initiated and its status is `PENDING`.
 */
export const onBackupRestorationStateChanged: BuildEventDefinition<
  typeof publicOnBackupRestorationStateChanged
> &
  typeof publicOnBackupRestorationStateChanged = createEventModule(
  publicOnBackupRestorationStateChanged
);

export {
  Status,
  Type,
  RestorationStatus,
  WebhookIdentityType,
} from './data-v2-backup-backups.universal.js';
export {
  Backup,
  Collection,
  BackupStateChanged,
  RestorationStateChanged,
  Restoration,
  RestorationCollection,
  RestoreDestination,
  CreateBackupRequest,
  CreateBackupResponse,
  ListBackupsRequest,
  Paging,
  ListBackupsResponse,
  PagingMetadataV2,
  RestoreBackupRequest,
  RestoreBackupResponse,
  RestorePartialBackupRequest,
  RestorePartialBackupResponse,
  ListRestorationsRequest,
  ListRestorationsResponse,
  DeleteBackupRequest,
  DeleteBackupResponse,
  CancelBackupRequest,
  CancelBackupResponse,
  MigrateNamespaceRequest,
  MigrateNamespaceResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  DisableInstanceRequest,
  Empty,
  EnableInstanceRequest,
  DeleteAllRequest,
  GetBackupMetadataRequest,
  GetBackupMetadataResponse,
  RebuildRequest,
  MoveRequest,
  RemoveDeletedRequest,
  FailRestorationRequest,
  TakeBackupRequest,
  UpdateBackupMetadataRequest,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  BackupStateChangedEnvelope,
  BackupRestorationStateChangedEnvelope,
  ListBackupsOptions,
  ListRestorationsOptions,
} from './data-v2-backup-backups.universal.js';
export {
  StatusWithLiterals,
  TypeWithLiterals,
  RestorationStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './data-v2-backup-backups.universal.js';
